import React, { useEffect, useState, useContext } from "react";
import { Carousel } from "react-responsive-carousel";
import "./restImageCarousel.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { db, firestoreDB } from "../../../../config/firebase_config";
import { ref, get } from "firebase/database";
import RestBanners from "../../../../models/Restaurent_banners";
import RestaurentContext from "../../../../context/rest_context";
import { CarouselSkeleton } from "../../../../components/skeletons/skeletons.jsx";
import { ArrowLeft, Bookmark, Share2, Image as ImageIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import RestGallery from "./RestGallery";
import { collection, getDocs, query, where } from "firebase/firestore";

const RestImageCarousel = ({ restID, restaurantName, priceForTwo }) => {
  const { restBanners, setRestBanners } = useContext(RestaurentContext);
  const navigate = useNavigate();
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: restaurantName || document.title,
          url: window.location.href,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(window.location.href);
        toast.success("Link copied to clipboard");
      } catch (err) {
        console.error("Error copying link:", err);
        toast.error("Failed to copy link");
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(
          collection(firestoreDB, "StoreGallery"),
          where("restId", "==", restID)
        );
        const snapshot = await getDocs(q);
        const gallery = [];

        // let banners = [];
        snapshot.forEach((doc) => {
          gallery.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setRestBanners([...gallery]);
        if (snapshot.exists()) {
        } else {
          const dummyBanners = [
            new RestBanners({ imageURL: "/1.jpg" }),
            new RestBanners({ imageURL: "/2.jpg" }),
            new RestBanners({ imageURL: "/3.jpg" }),
            new RestBanners({ imageURL: "/4.jpg" }),
            new RestBanners({ imageURL: "/5.jpg" }),
          ];
          setRestBanners(dummyBanners);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [restID, setRestBanners]);

  // Group banners into sets of 3 for mosaic layout
  const groupedBanners = [];
  for (let i = 0; i < restBanners.length; i += 3) {
    groupedBanners.push(restBanners.slice(i, i + 3));
  }


  console.log({ restBanners, restID });
  if (restBanners.length === 0) {
    return <CarouselSkeleton />;
  }

  return (
    <div className="rest-carousel-main-container">
      <Carousel
        className="rest-mosaic-carousel"
        autoPlay={false}
        showThumbs={false}
        infiniteLoop={true}
        showArrows={false}
        showStatus={false}
        showIndicators={false}
      // renderIndicator={(onClickHandler, isSelected, index, label) => {
      //   return (
      //     <li
      //       className={`custom-indicator ${isSelected ? "active" : ""}`}
      //       onClick={onClickHandler}
      //       onKeyDown={onClickHandler}
      //       value={index}
      //       key={index}
      //       role="button"
      //       tabIndex={0}
      //       title={`${label} ${index + 1}`}
      //       aria-label={`${label} ${index + 1}`}
      //     />
      //   );
      // }}
      >
        {groupedBanners.map((group, groupIndex) => (
          <div className="mosaic-slide" key={groupIndex}>
            <div className="mosaic-grid">
              {/* Left Column */}
              <div className="mosaic-left">
                {group[0] && (
                  <div className="mosaic-item top-left">
                    <img src={group[0].imageURL} alt="Res 1" />
                    {groupIndex === 0 && (
                      <button className="overlay-back-btn" onClick={() => navigate(-1)}>
                        <ArrowLeft size={20} />
                      </button>
                    )}
                  </div>
                )}
                {group[1] && (
                  <div className="mosaic-item bottom-left">
                    <img src={group[1].imageURL} alt="Res 2" />
                  </div>
                )}
                {!group[1] && group[0] && (
                  <div className="mosaic-item bottom-left placeholder"></div>
                )}
              </div>

              {/* Right Column */}
              <div className="mosaic-right">
                {group[2] ? (
                  <div className="mosaic-item tall-right">
                    <img src={group[2].imageURL} alt="Res 3" />
                    <div className="overlay-actions">

                      <button className="action-btn" onClick={handleShare}><Share2 size={20} /></button>
                    </div>
                  </div>
                ) : (
                  group[0] && (
                    <div className="mosaic-item tall-right placeholder">
                      <div className="overlay-actions">

                        <button className="action-btn" onClick={handleShare}><Share2 size={20} /></button>
                      </div>
                    </div>
                  )
                )}
              </div>
              <button className="view-gallery-btn" onClick={() => setIsGalleryOpen(true)}>
                <ImageIcon size={16} />
                <span>View gallery</span>
              </button>
            </div>
          </div>
        ))}
      </Carousel>

      <RestGallery
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        images={restBanners}
        restaurantName={restaurantName || restBanners[0]?.restName}
        priceForTwo={priceForTwo}
      />
    </div >
  );
};

export default RestImageCarousel;
